module.exports = __webpack_public_path__ + "static/form-multiple-action-buttons-dont-66a1e40fb5903277338719fa4720c343.png";